import { render, staticRenderFns } from "./ExportTihuo.vue?vue&type=template&id=4900233e&scoped=true&"
import script from "./ExportTihuo.vue?vue&type=script&lang=js&"
export * from "./ExportTihuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900233e",
  null
  
)

export default component.exports